/**
 * Authentication Actions
 * Redux actions for authentication and user management
 */

import * as authService from '../../services/authService';
import { getAuthToken } from '../../services/apiConfig';

/**
 * Login user
 */
export const loginUser = (credentials) => async (dispatch) => {
  dispatch({ type: 'AUTH_START' });
  try {
    console.log('Login attempt with credentials:', { email: credentials.email || credentials.phone });
    const response = await authService.login(credentials);
    console.log('Login response:', response);
    
    // Extract user and token from response
    // Response structure: { success: true, data: { user: {...}, token: "..." } }
    const user = response.data?.user || response.user || response.data || null;
    const token = response.data?.token || response.token || response.accessToken || getAuthToken();
    
    if (token) {
      dispatch({
        type: 'AUTH_SUCCESS',
        payload: {
          user,
          token,
        },
      });
      return { success: true, data: response };
    } else {
      throw new Error('No token received from server');
    }
  } catch (error) {
    console.error('Login error:', error);
    const errorMessage = error.message || (error.data && (error.data.message || error.data.error)) || 'Login failed';
    dispatch({
      type: 'AUTH_FAILURE',
      payload: errorMessage,
    });
    return { success: false, error: errorMessage };
  }
};

/**
 * Register new user (Not available in admin panel)
 * @deprecated Admin panel does not support user registration
 */
export const registerUser = (userData) => async (dispatch) => {
  return { success: false, error: 'User registration not available in admin panel' };
};

/**
 * Logout user
 */
export const logoutUser = () => async (dispatch) => {
  authService.logout();
  dispatch({ type: 'AUTH_LOGOUT' });
};

/**
 * Get current user profile (Admin only - use admin APIs)
 * @deprecated Use admin user service instead
 */
export const getCurrentUser = () => async (dispatch) => {
  // Admin panel - user profile should be fetched via admin APIs
  const token = getAuthToken();
  if (token) {
    // For now, just set token in state
    dispatch({
      type: 'SET_USER',
      payload: { token },
    });
    return { success: true, data: { token } };
  }
  return { success: false, error: 'No token found' };
};

/**
 * Check if user is authenticated (from localStorage)
 */
export const checkAuth = () => async (dispatch) => {
  const token = getAuthToken();
  if (token) {
    // Set loading state while checking
    dispatch({ type: 'AUTH_START' });
    // For admin panel, just verify token exists
    // In future, can validate token with admin API
    dispatch({
      type: 'AUTH_SUCCESS',
      payload: {
        user: { token },
        token,
      },
    });
  } else {
    // No token, ensure we're logged out
    dispatch({ type: 'AUTH_LOGOUT' });
  }
};

/**
 * Update user data
 */
export const updateUserData = (userData) => (dispatch) => {
  dispatch({
    type: 'UPDATE_USER',
    payload: userData,
  });
};

/**
 * Update user profile (Admin only - use admin APIs)
 * @deprecated Use admin user service instead
 */
export const updateProfile = (profileData) => async (dispatch) => {
  return { success: false, error: 'Use admin APIs for profile updates' };
};

/**
 * Change user password (Admin only - use admin APIs)
 * @deprecated Use admin settings service instead
 */
export const changePassword = (passwordData) => async (dispatch) => {
  return { success: false, error: 'Use admin APIs for password changes' };
};

